// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ltts-run-model-content>div:not(first-child){margin-top:10px}.ltts-run-model-content-remove-mapping-icon{color:#ff4136}", ""]);
// Exports
module.exports = exports;
